export const ANDROID = 'android';
export const IOS = 'ios';

export function isIOS(os) {
  return os === IOS;
}

export function isAndroid(os) {
  return os === ANDROID;
}
